/**
 * @generated SignedSource<<43a24dad3601100d49f5f16b9be65bb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixAutomaticCompleted_subscription$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCompanyLogo_company">;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticAdditionalInfo_subscription" | "PaymentPixAutomaticRedirect_subscription" | "PaymentPixAutomaticTransactionInfo_subscription">;
  readonly " $fragmentType": "PaymentPixAutomaticCompleted_subscription";
};
export type PaymentPixAutomaticCompleted_subscription$key = {
  readonly " $data"?: PaymentPixAutomaticCompleted_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticCompleted_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixAutomaticCompleted_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanyLogo_company"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticAdditionalInfo_subscription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticRedirect_subscription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentPixAutomaticTransactionInfo_subscription"
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "2d238d9998921e57e152ead40aa2c539";

export default node;
